var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "lottery-container"
  }, [_c("a-row", {
    staticClass: "marginBottom",
    attrs: {
      gutter: 16
    }
  }, [_c("a-col", {
    attrs: {
      xs: 24,
      md: 24,
      sm: 24,
      lg: 24,
      xl: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("大转盘抽奖"),
      hoverable: true,
      bordered: false
    }
  }, [_c("circular")], 1)], 1), _c("a-col", {
    attrs: {
      xs: 24,
      md: 24,
      sm: 24,
      lg: 24,
      xl: 12
    }
  }, [_c("a-card", {
    attrs: {
      title: _vm.$t("九宫格抽奖"),
      hoverable: true,
      bordered: false
    }
  }, [_c("nine-lucky")], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };